(function () {
  'use strict';

  angular
    .module('admin.print_escrow.service', [])
    .factory('PrintEscrowService', PrintEscrowService);

  /** @ngInject */
  function PrintEscrowService($http, $q, API) {

    function list(start, limit, username, printId, printNumber) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/print_escrows/search?start=' + start + '&limit=' + limit + '&username=' + username + '&pId=' + printId + '&pNumber=' + printNumber)
        .success(defered.resolve);

      return defered.promise;
    }

    function listTransfer(start, limit, userFrom, userTo) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/print_transfer_logs/search?start=' + start + '&limit=' + limit + '&userFrom=' + userFrom + '&userTo=' + userTo)
        .success(defered.resolve);

      return defered.promise;
    }

    function getTransfer(id) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/print_transfer_logs/' + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function getPrintId(collectibleId, edition, number) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/prints/' + collectibleId + '/' + edition + '/' + number)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/print_escrows', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function saveTransfer(model) {
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/print_transfer_logs', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTransfer(id, model) {
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/print_transfer_logs/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/print_escrows/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
      listTransfer: listTransfer,
      getTransfer: getTransfer,
      save: save,
      getPrintId: getPrintId,
      saveTransfer: saveTransfer,
      updateTransfer: updateTransfer,
      remove: remove,
    };

  }

})();
